export default __webpack_public_path__ + "static/media/HST-Director.8bd34a13.svg";